import {useEffect,useState} from 'react';
import api from '../services/api';
export default function SeleccionPOPago({facturas,onChange}) {
  const [datos,setDatos]=useState([]),[seleccion,setSeleccion]=useState({}),[error,setError]=useState('');
  const ids=facturas.map(f=>f.idfactura).join(',');
  useEffect(()=>{
    let activo=true;setDatos([]);setSeleccion({});setError('');
    Promise.all(ids.split(',').filter(Boolean).map(id=>api.get(`/api/cartera/trazabilidad-po/${id}`).then(r=>({...r.data,idfactura:Number(id)}))))
      .then(rows=>{if(activo)setDatos(rows);}).catch(()=>{if(activo)setError('No se pudieron cargar los PO. Cierra y vuelve a abrir el pago.');});
    return()=>{activo=false;};
  },[ids]);
  useEffect(()=>{
    onChange(datos.map(f=>({idfactura:f.idfactura,revision:f.revision,seleccion:f.grupos.filter(g=>seleccion[`${f.idfactura}:${g.po}`]!==undefined).map(g=>({po:g.po,valor:Number(seleccion[`${f.idfactura}:${g.po}`])}))})).filter(f=>f.seleccion.length));
  },[datos,seleccion,onChange]);
  return <section>
    <p>Marca los PO que vas a pagar. Puedes ajustar el importe si el pago es parcial. El total se calcula con tu selección.</p>
    {error && <p role="alert">{error}</p>}
    {!datos.length&&!error&&<p>Cargando PO…</p>}
    {datos.map(f=><div key={f.idfactura}><strong>Factura {f.numero}</strong>
      {!f.grupos.length&&<p>Sin detalle de PO; utiliza el pago normal.</p>}
      {f.grupos.map(g=>{
        const key=`${f.idfactura}:${g.po}`;
        const asignado=f.historial.filter(h=>h.activo&&h.po===g.po).reduce((s,h)=>s+Math.round(h.valor*100),0);
        const disponible=Math.max(0,Math.round(g.valor*100)-asignado)/100;
        return <div key={key} style={{display:'flex',gap:12,alignItems:'center',margin:'8px 0'}}>
          <label><input type="checkbox" checked={seleccion[key]!==undefined} disabled={disponible<=0}
            onChange={e=>setSeleccion(prev=>{const next={...prev};if(e.target.checked)next[key]=disponible;else delete next[key];return next;})}/>{g.po} — ${g.valor.toFixed(2)} (sin asignar: ${disponible.toFixed(2)})</label>
          {seleccion[key]!==undefined&&<input aria-label={`Importe ${f.numero} ${g.po}`} type="number" min="0.01" step="0.01" max={disponible} value={seleccion[key]} onChange={e=>setSeleccion(prev=>({...prev,[key]:e.target.value}))}/>}
        </div>;
      })}
    </div>)}
  </section>;
}
